enum TableMode {
  Auto = "Auto",
  FullData = "FullData",
  Virtualized = "Virtualized",
  OldTable = "OldTable",
}

export default TableMode;
